import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const CentralGatewayPage = () => (
  <MarkdownPage file="CentralGateway.md" />
);
